// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import LoadScript from 'components/LoadScript/LoadScript'

// Redux:
import { getPageData } from 'actions/page'

class Comments extends React.Component {
	constructor() {
		super()

		this.state = {
			hasLoadedNext: false
		}
	}

	componentDidMount() {

	}

	componentDidUpdate( prevProps ) {
		const { currentlyViewedPage } = this.props

		if ( currentlyViewedPage && currentlyViewedPage.id != prevProps.currentlyViewedPage.id ) {
			if ( window.FB ) {
				FB.XFBML.parse()
			}
		}
	}

	handleWaypointEnter = () => {
		const { dispatch } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return
		}

		this.setState( {
			hasLoadedNext: true
		})

		// Fetch the next post:
		if ( page.next_post_slug ) {
			dispatch(
				getPageData( {
					type: 'post',
					slug: page.next_post_slug + '',
					requestOnly: true,
					append: true
				} )
			)
		}
	}

	render() {
		const { currentlyViewedPage } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		const { hasLoadedNext } = this.state

		if ( ! currentlyViewedPage ) {
			return null
		}

		return (
			<div className="comments-wrap">
				<LoadScript
					src={ `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=${siteData.facebook_app_id}` }
				/>

				{ ! hasLoadedNext &&
					<div className="-waypoint">
						<Waypoint
							onEnter={ this.handleWaypointEnter }
						/>
					</div>
				}

				{ currentlyViewedPage.id == page.id &&
					<div
						className="fb-comments"
						data-href={ siteData.site_url + currentlyViewedPage.url }
						data-numposts="10"
						data-width="100%"
					/>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default connect( mapStateToProps )( Comments )
